import {
  popupStore,
  userInfoStore,
  applicationStore,
  gameConfigStore,
} from '@pascal/pascal-core/shared/core/store';
import { DefaultQueryParams, loadingStore, parseQuery } from '@pascal/pascal-core';

import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { gameStore } from '../store/gameStore';
import { roundTimeStore } from '../store/roundTimeStore';

import { worker } from '../index';
import { doBetStore } from '../store/doBetStore';
import { winningStore } from '../store/winningStore';
import { liveConnection } from '../core';
import { limitsAndPayoutsStore } from '../store/limitsAndPayoutsStore';
import { gameLiveConnection } from './GameConnection';
import { autoBetStore } from '../store/autoBetStore';

let timeOutId;

class GameService {
  onGetInitialStateResult({
    rate,
    // cards,
    limits,
    balance,
    precision,
    // roundInfo,
    // lastResults,
    currencyCode,
    gameConfiguration,
    // isTestPlatform,
    // currentBet,
    // gameTypeInfo,
  }) {
    const {
      [DefaultQueryParams.CurrencySymbol]: currencySymbol,
      [DefaultQueryParams.UserId]: userId,
    } = parseQuery(window.location.search);
    userInfoStore.setUserInfo({
      rate,
      userId,
      balance,
      precision,
      currencyCode,
      currencySymbol,
      demoBalance: 10000,
    });
    const { limitsAndPayouts } = gameConfiguration;
    limitsAndPayoutsStore.setLimitsAndPayouts(limitsAndPayouts);
    gameConfigStore.setLimits(limits);
    doBetStore.setQuickBets(limits.quickBets);
    doBetStore.setSelectedAmount(limits.quickBets[0]);
    applicationStore.setIsDemo(true);
    loadingStore.updateLoading({ isGameInitialLoaded: true });
  }

  handleDoBetResult() {}

  handleDoBetResultValidation() {}

  handleRoundStart() {}

  handleResultReport() {}

  handleRoundFin() {}

  handleBetsClosed() {}

  socketRecursiveReconnecting() {
    try {
      liveConnection
        .restartGameConnection()
        .then((connectionData) => {
          liveConnection.connectionInitCallback(connectionData);
          clearTimeout(timeOutId);
        })
        .catch(() => {
          timeOutId = setTimeout(() => {
            this.socketRecursiveReconnecting();
          }, 4000);
        });
    } catch (err) {
      popupStore.open({ name: PopUps.ConnectionError });
      popupStore.onConnectionError(true);
    }
  }

  handleReconnecting(error) {
    if (error && error.message) {
      // eslint-disable-next-line
      popupStore.open({ name: PopUps.ConnectionError });
      popupStore.onConnectionError(true);
      // popupStore.toggleReconnect();
      // this.socketRecursiveReconnecting();
    } else {
      GameService.ReconnectCount += 1;
      popupStore.open({ name: PopUps.Reconnect });
      popupStore.toggleReconnect();
    }
  }

  handleReconnected() {
    GameService.ReconnectCount = 0;
    if (popupStore.popupName !== PopUps.ConnectionError) {
      gameLiveConnection.sendGameGetInitialState(false).then(() => {});
      // popupStore.toggleReconnect();
      // popupStore.close();
    }
  }

  handleConnectionError() {
    if (GameService.ReconnectCount) {
      popupStore.open({ name: PopUps.ConnectionError });
      popupStore.onConnectionError(true);
    }
  }

  handleGameOpen() {
    winningStore.setLastWin(0);
    winningStore.clearWinInfo();
    gameStore.setIsBetsClosed(false);
    autoBetStore.resetAutoBet();

    gameLiveConnection.stop();
  }

  countDown({ data: time }) {
    roundTimeStore.setTime(time);
  }

  sendWorker(timerValue) {
    if (timerValue) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage(timerValue);
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }
}

export const gameService = new GameService();
